'use client';

import { useEffect } from 'react';
import AOS from 'aos';

import 'aos/dist/aos.css';

let initialized = false;

// Recompute cached element positions once the page layout has settled
// (streamed hydration, images, fonts, collapsed cards all shift content).
export function refreshAOS() {
  if (typeof window !== 'undefined') {
    (window as unknown as { AOS?: typeof AOS }).AOS?.refresh();
  }
}

export function useAOS() {
  useEffect(() => {
    if (initialized) {
      return;
    }
    initialized = true;

    AOS.init({
      duration: 1000, // Durée des animations (en ms)
      anchorPlacement: 'bottom-bottom',
    });
    (window as unknown as { AOS?: typeof AOS }).AOS = AOS;

    const delayedRefresh = () => setTimeout(() => AOS.refresh(), 300);
    if (document.readyState === 'complete') {
      delayedRefresh();
    } else {
      window.addEventListener('load', delayedRefresh, { once: true });
    }
    // Catch layout shifts that settle after the load event (late hydration,
    // webfonts, lazy media). AOS.refresh() is cheap on these page sizes.
    setTimeout(() => AOS.refresh(), 1500);
  }, []);
}
